module.exports = __webpack_public_path__ + "img/Lane Hall 3.44654db7.jpg";